"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
exports.ONE_SECOND_IN_MS = 1000;
exports.ONE_HOUR_IN_MS = 60 * 60 * 1000;
exports.ONE_MINUTE_IN_MS = 60 * 1000;
function getTime(createdAt) {
    var duration = Date.now() - createdAt;
    var hours = duration >= 0 ? Math.floor(duration / exports.ONE_HOUR_IN_MS).toString() : 0;
    var minutes = duration >= 0 ? Math.floor((duration - +hours * exports.ONE_HOUR_IN_MS) / exports.ONE_MINUTE_IN_MS).toString() : 0;
    var seconds = Math.round((duration - +hours * exports.ONE_HOUR_IN_MS - +minutes * exports.ONE_MINUTE_IN_MS) / exports.ONE_SECOND_IN_MS).toString();
    if (+hours < 10) {
        hours = '0' + hours;
    }
    if (+minutes < 10) {
        minutes = '0' + minutes;
    }
    if (+seconds >= 0 && +seconds < 10) {
        seconds = '0' + seconds;
    }
    return hours + " : " + minutes + " : " + seconds;
}
exports.getTime = getTime;
;
function getChatMessage(message) {
    return {
        message: message,
        timestamp: new Date().valueOf(),
        type: 1
    };
}
exports.getChatMessage = getChatMessage;
;
function calculateMemberTotalPage(memberParticipantsCount, memberParticipantsPagingStartIndex, participantsPerPageCount) {
    return Math.ceil((memberParticipantsCount - memberParticipantsPagingStartIndex) / participantsPerPageCount);
}
exports.calculateMemberTotalPage = calculateMemberTotalPage;
function reorderSpeaker(participants, participant, participantsTotalPages, participantsPagingStartIndex) {
    var index = participants.indexOf(participant);
    if (index !== 0) {
        participants.splice(index, 1);
        participants.unshift(participant);
    }
    // Todo need to return
    participantsTotalPages = calculateMemberTotalPage(participants.length, 1, constants_1.AppConstants.PARTICIPANTS_PER_PAGE);
    participantsPagingStartIndex = 1;
}
exports.reorderSpeaker = reorderSpeaker;
;
function getParticipantsPagingStartIndex(participants, lastActiveParticipant) {
    if (participants && participants[0] === lastActiveParticipant) {
        return 1;
    }
    return 0;
}
exports.getParticipantsPagingStartIndex = getParticipantsPagingStartIndex;
exports.filterParticipantsByUserID = function (participants, currentUserInfo) {
    return participants.filter(function (participant) { return participant.USERID !== currentUserInfo.USERID; });
};
exports.filterAllParticipants = function (vcParticipantsRoleMapping, currentUserRole, currentUserInfo) {
    var data = [];
    vcParticipantsRoleMapping.forEach(function (participants, key) {
        data.push.apply(data, participants.filter(function (participant) {
            return !((currentUserRole && currentUserRole.toLowerCase() === key.toLowerCase())
                && participant.USERID === currentUserInfo.USERID)
                && participant.connected;
        }).map(function (participantData) { return participantData.participant; }));
    });
    return data;
};
//# sourceMappingURL=utils.js.map